import { render, staticRenderFns } from "./VoteRating.vue?vue&type=template&id=07c59c6d&scoped=true"
import script from "./VoteRating.vue?vue&type=script&lang=js"
export * from "./VoteRating.vue?vue&type=script&lang=js"
import style0 from "./VoteRating.vue?vue&type=style&index=0&id=07c59c6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c59c6d",
  null
  
)

export default component.exports